export const PLAYER = {
    crosses: 'X',
    noughts: 'O',
};
